// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1L7gG","rootMobile":"styles_rootMobile__2EC81"};